export default "__VITE_ASSET__DwgTlq10__"